'use client';

import Image from '@/components/Image';

const DEFAULT_ALT = '$15 off $125+ with Klarna, limited-time offer';

const KlarnaPromotionBanner: React.FC = () => {
  return (
    <div className="py-8">
      <Image
        src="/payment/KlarnaPromotion.png"
        alt={DEFAULT_ALT}
        width={1041}
        height={300}
        className="block h-auto w-full"
      />
    </div>
  );
};

export default KlarnaPromotionBanner;
